import { GNS3_REASON, WhyGNS3List } from "./constants";
import { Text, UnorderedList, ListItem, Flex, Box, Heading } from "@chakra-ui/react";
import { SectionDivider } from "@/app/components/shared/SectionDivider";

const WhyGNS3 = () => {
  return (
    <>
      <Box data-cy="section-why-GNS3">
        <SectionDivider label="What is GNS3 ?" />
        {GNS3_REASON.desc.map((Reason, index) => (
          <Text key={index} fontSize={{ base: "md", lg: "lg" }} color={"gray.700"}>
            {Reason}
          </Text>
        ))}
        <Text fontSize={{ base: "md", lg: "lg" }} color={"gray.700"} py={4}>
          Key Features of GNS3 include:
        </Text>
        <UnorderedList fontSize={"lg"} color={"gray.700"}>
          {GNS3_REASON.Points.map((item, index) => (
            <ListItem key={index}>{item}</ListItem>
          ))}
        </UnorderedList>
        <SectionDivider label="Why Choose GNS3 ?" />
        <Flex
          flexWrap="wrap"
          justifyContent="center"
          gap={"2%"}
          data-cy={"card-pricing"}
          mt={10}
        >
          {WhyGNS3List.map((data, index) => (
            <Box
              p={6}
              key={index}
              boxShadow={"md"}
              border={"1px solid #aaa"}
              borderRadius={"8px"}
              transition={"0.15s"}
              _hover={{
                transform: "scale(1.03)",
                boxShadow: "lg",
              }}
              height={"auto"}
              display="flex"
              flexDirection="column"
              alignItems="center"
              gap={"4px"}
              minWidth={"320px"}
              maxWidth={"24%"}
              marginBottom={8}
            >
              <Heading
                as={"h3"}
                textAlign={"center"}
                fontSize={{ base: "md", lg: "lg" }}
                color={"gray.700"}
                mb={3}
              >
                {data.title}
              </Heading>

              <Text key={index} fontSize={{ base: "md", lg: "lg" }} color={"gray.700"}>
                {data.desc}
              </Text>
            </Box>
          ))}
        </Flex>
      </Box>
    </>
  );
};

export default WhyGNS3;
